<div class="loader-wrapper d-flex flex-column gap-3 gap-lg-4 bg-white" *ngIf="loading">
   <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5px', height: '32px', 'background-color': '#ededed'}">
   </ngx-skeleton-loader>
   <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5px', height: '150px', 'background-color': '#ededed'}">
   </ngx-skeleton-loader>
   <ngx-skeleton-loader count="5" [theme]="{ 'border-radius': '5px', height: '16px', 'background-color': '#ededed'}">
   </ngx-skeleton-loader>
</div>

<div class="main-wrapper px-lg-0" *ngIf="!loading && _recommendation">
   <div class="analyst-ratings">
      <h2 class="analyst-ratings-heading">Analyst's Ratings for {{stockname}} ({{ticker}})</h2>
      <p class="analyst-ratings-para">
         Based on <strong class="fw-600">{{ recommendationCount }} analysts</strong> giving stock ratings to {{
         stockname }} in the past 3 months
         <span class="align-middle d-inline-block bg-transparent border-0 rounded-circle" placement="bottom"
            [ngbTooltip]="analystRatingDisclaimer">
            <svg xmlns="http://www.w3.org/2000/svg" class="info-icon" viewBox="0 0 24 24" width="16" height="16"
               color="#7e7e7e" fill="none">
               <path
                  d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                  stroke="currentColor" stroke-width="1.5" />
               <path d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
               <path d="M11.992 8H12.001" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
            </svg>
         </span>
      </p>

      <div class="chart-wrapper" *ngIf="guageValue > 0">
         <app-analyst-rating-guage-chart [value]="guageValue" [color]="recommendationColor">
         </app-analyst-rating-guage-chart>
      </div>

      <div class="ratings-progress-bar d-flex flex-column gap-3 mt-3">

         <article class="d-flex align-items-center gap-3">
            <span class="d-inline-block lh-1 text-nowrap rating-text">Strong Buy</span>
            <div class="rating-progress flex-grow-1">
               <div class="progress-value-bar strong-buy-bar" [ngStyle]="{ width: _recommendation?.strongBuy + '%' }">
               </div>
            </div>
            <span class="d-inline-block lh-1 rating-value">{{_recommendation?.strongBuy}}</span>
         </article>

         <article class="d-flex align-items-center gap-3">
            <span class="d-inline-block lh-1 text-nowrap rating-text">Buy</span>
            <div class="rating-progress flex-grow-1">
               <div class="progress-value-bar buy-bar" [ngStyle]="{ width: _recommendation?.buy + '%' }"></div>
            </div>
            <span class="d-inline-block lh-1 rating-value">{{_recommendation?.buy}}</span>
         </article>

         <article class="d-flex align-items-center gap-3">
            <span class="d-inline-block lh-1 text-nowrap rating-text">Hold</span>
            <div class="rating-progress flex-grow-1">
               <div class="progress-value-bar sell-bar" [ngStyle]="{ width: _recommendation?.hold + '%' }"></div>
            </div>
            <span class="d-inline-block lh-1 rating-value">{{_recommendation?.hold}}</span>
         </article>

         <article class="d-flex align-items-center gap-3">
            <span class="d-inline-block lh-1 text-nowrap rating-text">Sell</span>
            <div class="rating-progress flex-grow-1">
               <div class="progress-value-bar neutral-bar" [ngStyle]="{ width: _recommendation?.sell + '%' }"></div>
            </div>
            <span class="d-inline-block lh-1 rating-value">{{_recommendation?.sell}}</span>
         </article>

         <article class="d-flex align-items-center gap-3">
            <span class="d-inline-block lh-1 text-nowrap rating-text">Strong Sell</span>
            <div class="rating-progress flex-grow-1">
               <div class="progress-value-bar strong-sell-bar" [ngStyle]="{ width: _recommendation?.strongSell + '%' }">
               </div>
            </div>
            <span class="d-inline-block lh-1 rating-value">{{_recommendation?.strongSell}}</span>
         </article>

      </div>
      <!-- <p class="rounded analyst-rating-disclaimer mt-4 mb-0">
         {{analystRatingDisclaimer}}
      </p> -->
   </div>
</div>

<!-- <div *ngIf="!loading && !_recommendation">
   <app-no-data-card heading="Analysts’ Ratings"></app-no-data-card>
</div> -->

























<!-- <div class="loader-wrapper" *ngIf="loading">
   <ngx-skeleton-loader
     count="5"
     [theme]="{
       'border-radius': '5px',
        height: '40px',
       'background-color': '#ededed'
     }"
   ></ngx-skeleton-loader>
 </div>

<section class="recommendation main__box mt-0"  *ngIf="!loading && _recommendation">
   <header class="recommendation__header">
      <h2 class="recommendation__heading">Analysts’ Ratings</h2>

      <div
         class="recommendation__analysts"
         *ngIf="maxRecommendationName === 'Strong buy'"
         [ngClass]="{ 'strong-buy': maxRecommendationName === 'Strong buy' }"
      >
         <p>{{ maxRecommendationName }}</p>
      </div>

      <div
         class="recommendation__analysts"
         *ngIf="maxRecommendationName === 'BUY'"
         [ngClass]="{ buy: maxRecommendationName === 'BUY' }"
      >
         <p>{{ maxRecommendationName }}</p>
      </div>

      <div
         class="recommendation__analysts"
         *ngIf="maxRecommendationName === 'HOLD'"
         [ngClass]="{ hold: maxRecommendationName === 'HOLD' }"
      >
         <p>{{ maxRecommendationName }}</p>
      </div>

      <div
         class="recommendation__analysts"
         *ngIf="maxRecommendationName === 'SELL'"
         [ngClass]="{ sell: maxRecommendationName === 'SELL' }"
      >
         <p>{{ maxRecommendationName }}</p>
      </div>

      <div
         class="recommendation__analysts"
         *ngIf="maxRecommendationName === 'Strong sell'"
         [ngClass]="{ 'strong-sell': maxRecommendationName === 'Strong sell' }"
      >
         <p>{{ maxRecommendationName }}</p>
      </div>
   </header>
   <div class="recomendation__analiz">
      <span
         >Based on <strong>{{ recommendationCount }} analysts</strong> giving
         stock ratings to {{ stockname }} in the past 3 months</span
      >
   </div>
   <main class="recommendation__main">
      <ul class="recommendation-progress__ul">
         <li
            class="recommendation-progress__li recommendation-progress__li--strong-buy"
         >
            <div class="recommendation-progress__bar">
               <p class="recommendation-progress__name">Strong buy</p>

               <div class="recomendation__group">
                  <div
                     class="recommendation-progress__bar__active recommendation-progress__bar__active--strong-buy"
                     [ngStyle]="{
                        width: _recommendation.strongBuy + '%'
                     }"
                  >
                     <div class="recommendation-progress__bar__percent sb">
                        {{ _recommendation.strongBuy }}%
                     </div>
                  </div>

                  <div class="recommendation-progress__bar__disabled"></div>
               </div>
            </div>
         </li>
         <li
            class="recommendation-progress__li recommendation-progress__li--buy"
         >
            <div class="recommendation-progress__bar">
               <p class="recommendation-progress__name">Buy</p>
               <div class="recomendation__group">
                  <div
                     class="recommendation-progress__bar__active recommendation-progress__bar__active--buy"
                     [ngStyle]="{
                        width: _recommendation.buy + '%'
                     }"
                  >
                     <div class="recommendation-progress__bar__percent b">
                        {{ _recommendation.buy }}%
                     </div>
                  </div>

                  <div class="recommendation-progress__bar__disabled"></div>
               </div>
            </div>
         </li>
         <li
            class="recommendation-progress__li recommendation-progress__li--hold"
         >
            <div class="recommendation-progress__bar">
               <p class="recommendation-progress__name">Hold</p>
               <div class="recomendation__group">
                  <div
                     class="recommendation-progress__bar__active recommendation-progress__bar__active--hold"
                     [ngStyle]="{
                        width: _recommendation.hold + '%'
                     }"
                  >
                     <div class="recommendation-progress__bar__percent h">
                        {{ _recommendation.hold }}%
                     </div>
                  </div>

                  <div class="recommendation-progress__bar__disabled"></div>
               </div>
            </div>
         </li>
         <li
            class="recommendation-progress__li recommendation-progress__li--sell"
         >
            <div class="recommendation-progress__bar">
               <p class="recommendation-progress__name">Sell</p>

               <div class="recomendation__group">
                  <div
                     class="recommendation-progress__bar__active recommendation-progress__bar__active--sell"
                     [ngStyle]="{
                        width: _recommendation.sell + '%'
                     }"
                  >
                     <div class="recommendation-progress__bar__percent s">
                        {{ _recommendation.sell }}%
                     </div>
                  </div>

                  <div class="recommendation-progress__bar__disabled"></div>
               </div>
            </div>
         </li>
         <li
            class="recommendation-progress__li recommendation-progress__li--strong-sell"
         >
            <div class="recommendation-progress__bar">
               <p class="recommendation-progress__name">Strong sell</p>
               <div class="recomendation__group">
                  <div
                     class="recommendation-progress__bar__active recommendation-progress__bar__active--strong-sell"
                     [ngStyle]="{
                        width: _recommendation.strongSell + '%'
                     }"
                  >
                     <div class="recommendation-progress__bar__percent ss">
                        {{ _recommendation.strongSell }}%
                     </div>
                  </div>

                  <div class="recommendation-progress__bar__disabled"></div>
               </div>
            </div>
         </li>
      </ul>

   </main>
   <div class="recomendation__analiz__mob d-lg-none">
      <span
         >Based on <strong>{{ recommendationCount }} analysts</strong> giving
         stock ratings to {{ stockname }} in the past 3 months</span
      >
   </div>
</section>

<div *ngIf="!loading && !_recommendation">
   <app-no-data-card heading="Analysts’ Ratings"></app-no-data-card>
</div> -->
